import { Styles } from 'shared/types';

export const MainContainer: Styles = {
  px: 3,
  py: 2,
};
